import { orchestrator } from 'satcheljs';
import { updateSelectedDate } from '../actions/publicActions';
import { updateDateRange } from 'owa-calendar-events-loader';
import {
    getScenarioListCacheId,
    getInitialDateRange,
    shouldShowTasks,
} from '../selectors/agendaStoreSelectors';
import { getLoadedDateRange } from '../selectors/listEventsCalendarCacheSelectors';
import { differenceInDays } from 'owa-datetime';
import { isDateInDateRange, createDateRange } from 'owa-datetime-utils';
import { getScenarioActions } from '../actions/getScenarioActions';
import { getTodoCache } from '../store/todoCache';
import { TodoDescriptorType } from 'owa-todo-cache';

export const updateSelectedDateOrchestrator = orchestrator(updateSelectedDate, actionMessage => {
    const { date, scenarioId } = actionMessage;
    const newDateRange = getInitialDateRange(scenarioId, date);

    // if date is inside the existing loaded date range, don't go anywhere
    const existingRange = getLoadedDateRange(scenarioId);

    if (existingRange) {
        const scrollRange = createDateRange(
            existingRange.start,
            differenceInDays(existingRange.end, existingRange.start)
        );
        if (isDateInDateRange(scrollRange, newDateRange.start)) {
            getScenarioActions(scenarioId).scrollToDateHeader(newDateRange.start);
            return;
        }
    }

    if (shouldShowTasks(scenarioId)) {
        getTodoCache(scenarioId).fetchTasks({
            type: TodoDescriptorType.DueDate,
            startDate: newDateRange.start,
            endDate: newDateRange.end,
        });
    }

    updateDateRange(newDateRange, getScenarioListCacheId(scenarioId));
});
